import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
import { isEmpty } from 'lodash';
export const reportFormsListImportLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        const newParams = {
            ...params,
        };
        if (!!params.createTime && !isEmpty(params.createTime)) {
            newParams.createTimeStart = params.createTime.start;
            newParams.createTimeEnd = params.createTime.end;
            delete newParams.createTime;
        }
        if (!!params.processTime && !isEmpty(params.processTime)) {
            newParams.processTimeStart = params.processTime.start;
            newParams.processTimeEnd = params.processTime.end;
            delete newParams.processTime;
        }
        config.apiPath = `/uploadManage`;
        return api.get(newParams, config);
    },
};

export const reportFormsListExportLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        const newParams = {
            ...params,
        };
        if (!!params.createTime && !isEmpty(params.createTime)) {
            newParams.createTimeStart = params.createTime.start;
            newParams.createTimeEnd = params.createTime.end;
            delete newParams.createTime;
        }
        if (!!params.processTime && !isEmpty(params.processTime)) {
            newParams.processTimeStart = params.processTime.start;
            newParams.processTimeEnd = params.processTime.end;
            delete newParams.processTime;
        }
        config.apiPath = `/exportQueQue`;
        return api.get(newParams, config);
    },
};
